import axios from 'axios'

function downloadFile(url, file, type) {
  const options = {
    headers: {'accept': type},
    responseType: 'blob',
  };

  return axios.get(url, options).then(response => {
    const blob = new Blob([(response.data)], {type: type});
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.id = 'tmp-file-download';
    anchor.setAttribute('download', file);
    document.body.appendChild(anchor);
    anchor.click();
    document.getElementById(anchor.id).remove();
  })
    .catch(error => {
      console.error('Error downloading the file:', error);
    });
}

export default {
  downloadGNP: () => downloadFile(`/api/stores/card/service-account-gnp`, 'convenzione_gnp.csv', 'text/csv'),
}
